import React, { Component } from 'react'
import { ChromePicker } from 'react-color'
import  OnClickOutside  from './OnClickOutside'

import './style.css'

const ColorPreview = ({ color, onClick = () => {} }) => (
    <div className="color-preview-container" onClick={onClick}>
        <div className="color-preview-square" style={{ background: color }}></div>
        <div className="color-preview-value">{color}</div>
    </div>
)

export class ColorPicker extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      isColorPickerOpen: false
    }
  }

  onClickColor = () => {
    this.setState(prevState => ({
      isColorPickerOpen: !prevState.isColorPickerOpen,
    }))
  }

  render() {
    const { isColorPickerOpen } = this.state
    const { color, onColorChange } = this.props
    return (
      <div>
        <div className="color-picker-color-option">
          <label>Color</label>
          <ColorPreview color={color} onClick={this.onClickColor} />
          {isColorPickerOpen &&
            <OnClickOutside className="color-picker-color-picker-container" onClickOutside={this.onClickColor}>
              <ChromePicker
                color={color}
                onChangeComplete={onColorChange}
                disableAlpha
              />
            </OnClickOutside>
          }
        </div>
      </div>
    )
  }
}

export class GradientPicker extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      isFirstGradientOpen: false,
      isSecondGradientOpen: false
    }
  }

  onClickFirstGradient = () => {
    this.setState(prevState => ({
      isFirstGradientOpen: !prevState.isFirstGradientOpen,
      isSecondGradientOpen: false,
    }))
  }

  onClickSecondGradient = () => {
    this.setState(prevState => ({
      isFirstGradientOpen: false,
      isSecondGradientOpen: !prevState.isSecondGradientOpen,
    }))
  }

  render() {
    const { isFirstGradientOpen, isSecondGradientOpen } = this.state
    const { firstBackgroundGradient, secondBackgroundGradient, onFirstBgColorChange, onSecondBgColorChange } = this.props

    return (
      <div>
        <div className="color-picker-color-option">
          <label>Color 1</label>
          <ColorPreview color={firstBackgroundGradient} onClick={this.onClickFirstGradient} />
          {isFirstGradientOpen &&
            <OnClickOutside className="color-picker-color-picker-container" onClickOutside={this.onClickFirstGradient}>
              <ChromePicker
                color={firstBackgroundGradient}
                onChangeComplete={onFirstBgColorChange}
                disableAlpha
              />
            </OnClickOutside>
          }
        </div>
        <div className="color-picker-color-option">
          <label>Color 2</label>
          <ColorPreview color={secondBackgroundGradient} onClick={this.onClickSecondGradient} />
          {isSecondGradientOpen &&
            <OnClickOutside className="color-picker-color-picker-container" onClickOutside={this.onClickSecondGradient}>
              <ChromePicker
                color={secondBackgroundGradient}
                onChangeComplete={onSecondBgColorChange}
                disableAlpha
              />
            </OnClickOutside>
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ColorPicker/index.js